<template>
  <div class="page-container">
    <div class="content-wrapper">

      <!-- Header -->
      <PageHeader 
        :current-page="'hot-jobs'" 
        :islogin="islogin"
        :active-side="activeSide"
        :avatar="avatar"
        :nickname="nickname"
        @switch-side="handleSwitch"
        @logout="handleLogout"
      />

      <!-- Hot Jobs Section -->
      <div class="hot-jobs-container">
        <!-- Search and Filter Bar -->
        <div class="search-filter-bar">
          <div class="search-tabs">
            <div class="tabs-wrapper">
              <span class="tab tab-companies active">相关岗位</span>
            </div>
           
            <div class="search-section">
            <div class="search-box">
              <div class="search-left">
                <img class="icon-search" src="@/views/index/assets/img/serach.png" alt="search" />
                <input class="search-input" type="text" placeholder="请输入职位名称、公司等关键词" v-model="searchParams.keyword" @keyup.enter="applyFilters" />
              </div>
              <div class="search-right">
                <div class="expect-select-wrapper">
                  <span class="label">求职期望:</span>
                  <el-select
                    v-model="searchParams.job_objective"
                    placeholder="请选择求职期望"
                    clearable
                    class="expect-select-el"
                    @change="handleExpectationChange"
                  >
                    <el-option
                      v-for="expectation in interviewList"
                      :key="expectation.id"
                      :label="expectation.job_objective"
                      :value="expectation.job_objective"
                    />
                  </el-select>
                </div>
                <button class="btn-add-expect" @click="addJobExpectation">+ 添加求职期望</button>
              </div>
            </div>
          </div>
          </div>

          <div class="filter-row">
            <select class="filter-select" v-model="searchParams.city" @change="applyFilters">
              <option value=''>城市:全国</option>
              <option v-for="city in HOT_CITIES" :key="city" :value="city">{{ city }}</option>
            </select>
            <select class="filter-select" v-model="searchParams.education" @change="applyFilters">
              <option value=null>求职要求:不限</option>
              <option :value="option.value" :key="option.value" v-for="option in EDUCATION_OPTIONS">
                {{ option.label }}
              </option>
            </select>
            <select class="filter-select" v-model="searchParams.recruitment_type" @change="applyFilters">
              <option value=''>招聘类型:不限</option>
              <option :value="option.value" :key="option.key" v-for="option in RECRUITMENT_TYPES">
                {{ option.label }}
              </option>
            </select>
            <select class="filter-select" v-model="searchParams.publish_days" @change="applyFilters">
              <option :value="option.value" :key="option.value" v-for="option in PUBLISH_DAYS_OPTIONS">
                {{ option.label }}
              </option>
            </select>
            <span class="favorites-link" :class="{ active: showJobFavorites }" @click="goToMyFavorite">我的收藏</span>
            <button class="reset-filters-btn" @click="resetFilters">重置筛选</button>
          </div>
        </div>
        <div class="main-content-area">
          <!-- 相关岗位视图 -->
          <div class="job-listings-panel" ref="jobListPanel" @scroll="handleJobsScroll">
            <div 
              v-for="job in hotJobs" 
              :key="job.id" 
              :class="['job-card', { selected: selectedJob && selectedJob.id === job.id }]"
              @click="selectJob(job)"
            >
              <div class="job-header">
                <div class="job-title-with-tags">
                  <h3 class="job-title" :title="job.title">{{ job.title || job.company_name }}</h3>
                  <div class="job-tags">
                    <span class="tag" :class="getRecruitmentTypeClass(job.recruitment_type)">{{ getRecuitmenntLabel(job.recruitment_type) }}</span>
                  </div>
                </div>
                <div class="job-salary">{{ formatSalary(job.salary_start, job.salary_end, job.salary_month) || job.salary }}</div>
              </div>
              <div class="job-details">
                <span v-show="job.work_nature">{{ job.work_nature }}</span>
                <span>{{ getEducationLabel(job.education) }}</span>
                <span>{{ getExperienceText(job.experience) }}</span>
              </div>
              <div class="company-info">
                <div class="company-logo">
                  <img v-if="job.company_logo" :src="job.company_logo" :alt="job.company_name">
                  <div v-else class="company-logo-text">{{ getCompanyAvatar(job.company_name) }}</div>
                </div>
                <div class="company-details">
                  <div class="company-name">{{ job.company_name }}</div>
                  <div class="company-desc">{{ job.category }}</div>
                </div>
                <div class="job-location">{{ job.city }}</div>
              </div>
            </div>
            
            <!-- 无数据时显示空状态 -->
            <div v-if="hotJobs.length === 0" class="empty-state hot-jobs-loading">
              <img src="@/assets/image/loading.png" style="width: 500px;" alt="loading" />
            </div>
          <!-- 触底哨兵：用于自动加载更多 -->
          <div ref="jobsEndSentinel" class="infinite-sentinel"></div>
          </div>

          <JobDetailSection
            v-if="selectedJob && hotJobs.length > 0"
            ref="globalJobDetailSection"
            :job="selectedJob"
            context="global"
            :map-loading="!isAmapLoaded"
            map-ref="amapContainer"
            @favorite="toggleFavorite"
          >
            <div class="company-info-section">
              <h3 class="section-title">公司信息</h3>
              <div class="company-card" @click="viewCompanyFromJob(selectedJob)">
                <div class="company-logo">
                  <img v-if="selectedJob.company_logo" :src="selectedJob.company_logo" :alt="selectedJob.company_name">
                  <div v-else class="company-logo-text">{{ getCompanyAvatar(selectedJob.company_name) }}</div>
                </div>
                <div class="company-details">
                  <div class="company-name">{{ selectedJob.company_name }}</div>
                  <div class="company-info-text">
                    {{ selectedJob.category }} | {{ selectedJob.city }}
                  </div>
                  <div class="company-info-text">
                   {{ selectedJob.company_profile }}
                  </div>
                </div>
                <div class="company-arrow">→</div>
              </div>
            </div>

            <div class="action-buttons">
              <button class="btn-interview" @click="goToInterview(selectedJob)">面试此岗</button>
              <button class="btn-apply" @click="startSubmit(selectedJob)">开始投递</button>
            </div>
          </JobDetailSection>
        </div>
      </div>
      
      <!--  -->
      <!-- 投递成功弹框 -->
      <div v-if="deliverSuccessVisible" class="confirm-overlay" @click="deliverSuccessVisible = false">
        <div class="confirm-dialog deliver-success" @click.stop>
          <img class="success-illust" :src="deliverSuccessImg" alt="投递成功" />
          <div class="success-title">投递成功</div>
          <div class="success-desc">请留意您的手机来电、短信及邮箱等联系方式，避免错过沟通消息，预祝您拿下 Offer！</div>
          <button class="dd-btn dd-primary" @click="deliverSuccessVisible = false">关闭</button>
        </div>
      </div>
    </div>

    <!-- 投递材料选择弹窗（公共组件） -->
    <SubmitMaterialDialog 
      :visible.sync="showSubmitDialog"
      :show-resume="true"
      :show-interview="true"
      :job="jobActionContext || selectedJob"
      @submit="onSubmitMaterials"
    />

    <!-- 会话存在确认弹框（参考聊天页确认删除弹框风格） -->
    <div v-if="showConfirmSubmit" class="confirm-overlay" @click="showConfirmSubmit=false">
      <div class="confirm-dialog" @click.stop>
        <div class="font-color fs-24">{{ confirmMsg }}?</div>
        <div class="dd-desc"></div>
        <div class="dd-actions">
          <button class="dd-btn dd-cancel" @click="showConfirmSubmit=false">取消</button>
          <button class="dd-btn button-color" @click="confirmProceedSubmit">继续投递</button>
        </div>
      </div>
    </div>

    <!-- 求职期望弹框（公共组件） -->
    <JobExpectationDialog
      :visible.sync="showJobExpectationDialog"
      :editing-data="currentEditingExpectation"
      @submitted="onExpectationSaved"
      @close="resetExpectationDialog"
    />
  </div>
</template>

<script>
const JOB_LIST_PAGE_SIZE = 10

import { getUserInfo } from '@/api/user'
import { getHotJob, getJobsByIds } from '@/api/recommend'
import { addFavoriteJob, cancelFavoriteJob, getFavoriteJobList } from '@/api/job'
import { getUserExpectAll } from '@/api/user'
import SubmitMaterialDialog from '@/components/SubmitMaterialDialog/index.vue'
import JobExpectationDialog from '@/components/JobExpectationDialog/index.vue'
import JobDetailSection from '@/components/JobDetailSection.vue'
import PageHeader from '@/components/PageHeader/index.vue'
import {  EDUCATION_OPTIONS, RECRUITMENT_TYPES, PUBLISH_DAYS_OPTIONS, EXPERIENCE_OPTIONS, getEducationLabel, getWorkNatureLabel, getRecuitmenntLabel, getExperienceText, formatSalary } from '@/constants/jobConstants'
import { HOT_CITIES } from '@/constants/cityConstants'
import { lxUploadFile } from '@/api/upload'
import deliverySuccessImgUrl from '@/views/index/assets/img/deliverySuccess.png'
import favoriteActiveIconUrl from '@/views/hot-jobs/assets/img/favorite.png'
import favoriteDefaultIconUrl from '@/views/index/assets/img/star.png'
import { loadAmapScript } from '@/utils/loadAmap'

export default {
  components: {
    SubmitMaterialDialog,
    JobExpectationDialog,
    JobDetailSection,
    PageHeader
  },
  data() {
    return {
      activeSide: 'seek',
      islogin: false,
      isHeaderTransparent: true,
      showUserMenu: false,
      avatar: '',
      nickname: '',
      hotJobs: [],
      selectedJob: null,
      favoriteJobs: new Set(), // 存储已收藏的职位ID
      showJobFavorites: false,
      searchParams: {
        category: '',
        city: '',
        company_id: '',
        company_name: '',
        education: null,
        keyword: '',
        page_no: 1,
        page_size: JOB_LIST_PAGE_SIZE,
        publish_days: 0,
        salary_max: 0,
        salary_min: 0,
        sort_by: '',
        recruitment_type: '',
        job_keywords: null,
        job_objective: null,
        type: 1
      },
      jobSearchParams: {
        category: '',
        city: '',
        company_id: '',
        company_name: '',
        education: null,
        keyword: '',
        page_no: 1,
        page_size: JOB_LIST_PAGE_SIZE,
        publish_days: 0,
        salary_max: 0,
        salary_min: 0,
        sort_by: '',
        recruitment_type: '',
        job_keywords: null,
        job_objective: null,
        type: 1
      },
      // 列表加载更多状态
      isLoadingMore: false,
      hasMore: true,
      jobsFetched: false,
      jobsPageNo: 1,
      jobsHasMore: true,
      jobsIsLoading: false,
      showConfirmSubmit: false,
      pendingSubmit: null,
      // 求职期望选择相关
      selectedExpectationId: null, // 选中的期望ID
      // 投递材料弹窗相关
      showSubmitDialog: false,
      interviewList: [
      ],
      // 求职期望弹框相关
      showJobExpectationDialog: false,
      currentEditingExpectation: null,
      // 高德地图相关
      isAmapLoaded: false,
      amapInstance: null,
      amapMarker: null,
      AMapObj: null,
      globalMapContainer: null,
      EDUCATION_OPTIONS,
      RECRUITMENT_TYPES,
      PUBLISH_DAYS_OPTIONS,
      EXPERIENCE_OPTIONS,
      HOT_CITIES,
      // 筛选选项（写死的默认值）
      filterCityOptions: [
        ...HOT_CITIES.map(city => ({ value: city, label: city }))
      ],
      filterExperienceOptions: EXPERIENCE_OPTIONS,
      filterEducationOptions: EDUCATION_OPTIONS,
      // 投递成功弹框
      deliverSuccessVisible: false,
      deliverSuccessImg: deliverySuccessImgUrl,
      favoriteActiveIcon: favoriteActiveIconUrl,
      favoriteDefaultIcon: favoriteDefaultIconUrl,
      confirmMsg: '',
      jobActionContext: null,
      jobsScrollListenerAttached: false,
    };
  },
  computed: {
    educationMap() {
      const map = new Map();
      EDUCATION_OPTIONS.forEach(option => {
        map.set(option.value, option.label);
      });
      return map;
    },
  },
  watch: {
    '$route'(to) {
      this.syncPageWithRoute(to)
    },
    selectedJob(newJob) {
      // 当选中的职位变化时，更新地图
      if (newJob && newJob.job_address) {
        this.$nextTick(() => {
          if (!this.amapInstance) {
            this.initAmap()
          } else {
            this.updateMapLocation(newJob.job_address)
          }
        })
      }
    }
  },
  methods: {
    syncSearchCache() {
      this.jobSearchParams = { ...this.searchParams }
    },
    // 打开新的聊天页面（新窗口/新标签）
    openChatPage() {
      try {
        const routeData = this.$router.resolve({ name: 'chating' })
        const href = routeData && routeData.href ? routeData.href : '/chating'
        window.open(href, '_blank')
      } catch (e) {
        window.open('/chating', '_blank')
      }
    },
    getEducationLabel,
    getRecuitmenntLabel,
    // 初始化高德地图（动态加载 AMap）
    async initAmap() {
      const container = this.$refs.globalJobDetailSection && this.$refs.globalJobDetailSection.$refs ? this.$refs.globalJobDetailSection.$refs.amapContainer : null
      if (!container) {
        console.error('地图容器未找到')
        return
      }
      // 如果容器发生变化，销毁旧实例
      if (this.globalMapContainer && this.globalMapContainer !== container) {
        this.destroyAmap()
      }
      if (this.amapInstance) {
        // 已有实例时，仅更新位置
        if (this.selectedJob && this.selectedJob.job_address) {
          this.updateMapLocation(this.selectedJob.job_address)
        }
        return
      }
      
      // 动态加载高德地图 API
      try {
        await loadAmapScript()
        // 保存 AMap 引用
        this.AMapObj = window.AMap
      } catch (error) {
        console.error('高德地图API加载失败:', error)
        return
      }
      // 创建地图
      try {
        this.amapInstance = new this.AMapObj.Map(container, {
          zoom: 15,
          viewMode: '3D',
          pitch: 50,
          rotation: -15,
          mapStyle: 'amap://styles/fresh',
          features: ['bg', 'road', 'building', 'point']
        })
        this.globalMapContainer = container
      } catch (e) {
        console.error('初始化MAP失败:', e)
        this.isAmapLoaded = true
        return
      }
      if (this.selectedJob && this.selectedJob.job_address) {
        this.updateMapLocation(this.selectedJob.job_address)
      } else {
        this.isAmapLoaded = true
      }
    },
    destroyAmap() {
      try {
        if (this.amapInstance && typeof this.amapInstance.destroy === 'function') {
          this.amapInstance.destroy()
        }
      } catch (e) {
        console.warn('销毁岗位地图实例失败:', e)
      } finally {
        this.amapInstance = null
        this.amapMarker = null
        this.globalMapContainer = null
        this.isAmapLoaded = true
      }
    },
    // 根据地址更新地图
    async updateMapLocation(address) {
      if (!this.amapInstance) return
      const trimmed = String(address || '').trim()
      if (!trimmed) return
      try {
        const key = '113933dd80cbcb9f3372a68114f6fd9a'
        const url = `https://restapi.amap.com/v3/geocode/geo?address=${encodeURIComponent(trimmed)}&key=${key}`
        const resp = await fetch(url)
        const data = await resp.json()
        if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
          const [lng, lat] = data.geocodes[0].location.split(',').map(Number)
          const location = new this.AMapObj.LngLat(lng, lat)
          this.amapInstance.setCenter(location)
          if (this.amapMarker) this.amapInstance.remove(this.amapMarker)
          this.amapMarker = new this.AMapObj.Marker({
            position: location,
            title: trimmed
          })
          this.amapInstance.add(this.amapMarker)
          this.isAmapLoaded = true
        } else {
          this.isAmapLoaded = true
        }
      } catch (e) {
        console.error('更新地图位置失败:', e)
        this.isAmapLoaded = true
      }
    },
    async loadUserExpectList() {
      try {
        const res = await getUserExpectAll()
        this.interviewList =  res.data?.data || []
      } catch (e) {
        console.warn('获取求职期望失败:', e)
      }
    },

    async goToMyFavorite(){
      try {
        const res = await getFavoriteJobList({ page_no: 1, page_size: 20 })
        if (res && res.data && res.data.code === 1) {
          const lists = res.data.data?.lists || res.data.data || []
          this.hotJobs = lists
          this.selectedJob = this.hotJobs[0] || null
          this.searchParams.type = 1
          this.searchParams.page_no = 1
          this.jobsFetched = true
          this.jobsHasMore = false
          this.jobsPageNo = 1
          this.jobsIsLoading = false
          this.hasMore = false
          this.isLoadingMore = false
          this.jobSearchParams = { ...this.searchParams }
          this.showJobFavorites = true
          this.$message.success('已为你加载收藏职位')
        } else {
          this.$message.error(res?.data?.msg || '加载收藏失败')
        }
      } catch (e) {
        this.$message.error('加载收藏失败，请稍后重试')
      }
    },

    async startSubmit(job){
      const targetJob = job || this.selectedJob
      if (!targetJob) {
        this.$message.warning('请先选择一个职位')
        return
      }
      this.jobActionContext = targetJob
      this.showSubmitDialog = true
    },
    async onSubmitMaterials(payload, done, fail) {
      try {
        const targetJob = this.jobActionContext || this.selectedJob
        if (!targetJob) {
          this.$message.warning('暂无可投递职位')
          fail && fail()
          return
        }
          done && done()
      } catch (e) {
        console.error(e)
        this.$message.error('投递失败，请重试')
        fail && fail()
      } finally {
        this.deliveringInterview = false
        this.showInterviewSelectModal = false
        this.jobActionContext = null
      }
    },

    confirmProceedSubmit() {
      this.showConfirmSubmit = false
      this.showSubmitDialog = true
      
    },
    // 处理求职期望弹框提交
    onExpectationSaved () {
      this.loadUserExpectList()
      this.showJobExpectationDialog = false
      this.currentEditingExpectation = null
    },
    // 打开求职期望弹框（添加）
    addJobExpectation() {
      this.currentEditingExpectation = null
      this.showJobExpectationDialog = true
    },
    // 处理期望选择变化
    handleExpectationChange(job_objective) {
      if (job_objective) {
        // 根据选中的期望进行搜索筛选
        this.searchParams.job_keywords = job_objective
      } else {
        // 清空选择时重置搜索关键词
        this.searchParams.job_keywords = null
      }
      this.applyFilters()
    },

    // 重置弹框状态
    resetExpectationDialog() {
      this.currentEditingExpectation = null;
      this.editingExpectationIndex = null;
    },

    // 跳转到面试页面
    async goToInterview(job) {
      const targetJob = job || this.selectedJob
      if (!targetJob) {
        this.$message.warning('请先选择一个职位')
        return
      }
      try {
        // 在 localStorage 中存储面试来源信息
        const interviewSource = {
          interview_source: 1 // TODO: 待确认来源
        }
        localStorage.setItem('interviewSource', JSON.stringify(interviewSource))

        // 设置职位信息到 localStorage
        const position = targetJob.title || targetJob.job_title || ''
        // 解析岗位职责为数组（工作内容）
        let jobContent = []
        if (targetJob.description) {
          const pureText = String(targetJob.description).replace(/<[^>]*>/g, '').trim()
          jobContent = pureText.split(/\n+/)
            .map(line => line.trim())
            .filter(line => line && !line.startsWith('##'))
        }
        // 解析任职资格为数组（岗位要求）
        let jobRequirements = []
        if (targetJob.requirement) {
          const pureText = String(targetJob.requirement).replace(/<[^>]*>/g, '').trim()
          jobRequirements = pureText.split(/\n+/)
            .map(line => line.trim())
            .filter(line => line && !line.startsWith('##'))
        }
        
        const jobInformation = {
          position: position,
          jobContent: jobContent,
          jobRequirements: jobRequirements
        }
        localStorage.setItem('jobInformation', JSON.stringify(jobInformation))

        const jobSnapshot = { ...targetJob }

        const jd = await this.uploadJobDescription(targetJob)
        if (!jd) {
          const confirm = await this.$confirm('JD文件上传失败，是否继续跳转到面试页面？', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(() => false)
          if (!confirm) return
        }
        this.$store.commit('interviewState/SET_CURRENT_INTERVIEW_JOB', jobSnapshot)
        this.$router.push('/store/dashboard/profile')
      } catch (e) {
        this.$message.error('操作失败，请稍后重试')
      }
    },

    generateJobDescriptionTxt(job) {
      const targetJob = job || this.selectedJob
      if (!targetJob) return ''
      let txt = ''
      // 职位名称
      if (targetJob.title) txt += `职位名称：${targetJob.title}\n\n`
      // 岗位职责
      if (targetJob.description) {
        txt += '岗位职责：\n'
        const pure = String(targetJob.description).replace(/<[^>]*>/g, '').trim()
        txt = txt + pure + '\n'

      }
      // 任职资格
      if (targetJob.requirement) {
        txt += '任职资格：\n'
        const pure = String(targetJob.requirement).replace(/<[^>]*>/g, '').trim()
        txt = txt + pure + '\n'
      }
      return txt
    },

    async uploadJobDescription(job) {
      try {
        const targetJob = job || this.selectedJob
        const content = this.generateJobDescriptionTxt(targetJob)
        if (!content.trim()) {
          this.$message.warning('职位信息为空，无法生成JD文件')
          return null
        }
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
        const fileName = `${(targetJob && targetJob.title) || '职位描述'}_JD.txt`
        const file = new File([blob], fileName, { type: 'text/plain;charset=utf-8' })
        const form = new FormData()
        form.append('file', file)
        const resp = await lxUploadFile(form)
        const url = resp?.data?.data?.url
        const name = resp?.data?.data?.name || fileName
        if (url) {
          // 本地缓存与状态更新（如需）
          localStorage.setItem('jd_url', url)
          localStorage.setItem('jd_name', name)
          if (this.$store && this.$store.commit) {
            this.$store.commit('interviewState/SET_JD', { url, name, raw: file })
          }
          return { url, name }
        }
        throw new Error('上传响应无效')
      } catch (err) {
        console.error('上传JD失败:', err)
        this.$message.error('岗位JD文件上传失败，请稍后重试')
        return null
      }
    },
    
      
    handleSwitch(side) {
      this.activeSide = side;
    },
    handleLogout() {
      this.islogin = false;
      this.avatar = '';
      this.nickname = '';
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      this.$message.success('已退出登录');
    },
    async isLogin() {
      let res = await getUserInfo();
      if (res.data.code == 1) {
        this.avatar = res.data.data.avatar;
        this.nickname = res.data.data.real_name || res.data.data.nickname;
        this.islogin = true

      } else if (res.data.code == -1) {
        // 未登录状态
      }

    },
    handleScroll() {
      const scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      this.isHeaderTransparent = scrollTop < 50;
    },
    // 职位列表容器内部滚动触底
    handleJobsScroll() {
      const panel = this.$refs.jobListPanel
      if (!panel) return
      const scrollTop = panel.scrollTop
      const clientHeight = panel.clientHeight
      const scrollHeight = panel.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight - 200) {
        this.loadMoreHotJobs()
      }
    },
    syncPageWithRoute(route) {
      const targetPage = route && route.meta && route.meta.initialPage ? route.meta.initialPage : 'hot-jobs'
      if (targetPage !== 'hot-jobs') {
        this.detachJobListScrollListener()
        return
      }

      // 检查路由参数中是否有 tab 参数
      const tabFromRoute = route.query && route.query.tab
      if (tabFromRoute === 'jobs') {
        if (!this.hotJobs || !this.hotJobs.length) {
          this.searchParams.type = 1
          this.loadHotJobs()
        } else {
          if (!this.selectedJob && this.hotJobs.length > 0) {
            this.selectedJob = this.hotJobs[0]
            if (this.selectedJob && this.selectedJob.job_address) {
              this.$nextTick(() => {
                if (!this.amapInstance) {
                  this.initAmap()
                } else {
                  this.updateMapLocation(this.selectedJob.job_address)
                }
              })
            }
          }
        }
        return
      }

      // 优先处理 jobIds 参数（数组形式，用于推荐岗位）
      const jobIdsFromRoute = route.query && route.query.jobIds
      if (jobIdsFromRoute) {
        const jobIds = typeof jobIdsFromRoute === 'string' 
          ? jobIdsFromRoute.split(',').filter(id => id) 
          : Array.isArray(jobIdsFromRoute) 
            ? jobIdsFromRoute.filter(id => id) 
            : []
        
        if (jobIds.length > 0) {
          this.searchParams.page_no = 1
          this.hasMore = false // 使用 jobIds 时不需要分页
          this.isLoadingMore = false
          this.hotJobs = []
          this.selectedJob = null
          this.jobsFetched = false
          this.jobsPageNo = 1
          this.jobsHasMore = false
          this.jobsIsLoading = true
          this.searchParams.type = 1
          
          // 调用根据 jobIds 获取岗位的接口
          this.loadJobsByIds(jobIds)
          return
        }
      }

      const jobIdFromRoute = route.query && route.query.job_id
      if (jobIdFromRoute) {
        if (this.hotJobs && this.hotJobs.length) {
          const targetJob = this.hotJobs.find(job => 
            (job.id && String(job.id) === String(jobIdFromRoute)) || 
            (job.job_id && String(job.job_id) === String(jobIdFromRoute))
          )
          if (targetJob && (!this.selectedJob || (this.selectedJob.id !== targetJob.id && this.selectedJob.job_id !== targetJob.job_id))) {
            this.selectedJob = targetJob
            if (this.selectedJob && this.selectedJob.job_address) {
              this.$nextTick(() => {
                this.initAmap()
              })
            }
          }
          return
        }
        if (!this.jobsFetched) {
          this.searchParams.type = 1
          this.loadHotJobs()
        }
        return
      }

      // 如果没有路由参数，且数据已存在，不重新请求
      if (this.$route.name === 'hot-jobs' && this.hotJobs.length) {
        return
      }

      this.isHeaderTransparent = false
      this.searchParams.page_no = 1
      this.hasMore = true
      this.isLoadingMore = false
      this.hotJobs = []
      this.selectedJob = null
      this.jobsFetched = false
      this.jobsPageNo = 1
      this.jobsHasMore = true
      this.jobsIsLoading = false
      this.searchParams.type = 1
      this.jobSearchParams = { ...this.searchParams }
      this.loadHotJobs()
      this.$nextTick(() => {
        this.attachJobListScrollListener()
      })
    },
    attachJobListScrollListener() {
      const panel = this.$refs.jobListPanel
      if (panel && !this.jobsScrollListenerAttached) {
        panel.addEventListener('scroll', this.handleJobsScroll)
        this.jobsScrollListenerAttached = true
      }
    },
    detachJobListScrollListener() {
      const panel = this.$refs.jobListPanel
      if (panel && this.jobsScrollListenerAttached) {
        panel.removeEventListener('scroll', this.handleJobsScroll)
        this.jobsScrollListenerAttached = false
      }
    },
    async viewCompanyFromJob(job) {
      // 跳转到企业页面
      if (job && job.company_id) {
        this.$router.push({
          name: 'hot-companies',
          query: { company_id: job.company_id }
        })
      }
    },
    async loadJobsByIds(jobIds) {
      if (!jobIds || !Array.isArray(jobIds) || jobIds.length === 0) {
        this.jobsIsLoading = false
        return
      }

      this.jobsIsLoading = true
      try {
        const response = await getJobsByIds({ job_ids: jobIds })
        if (response.data.code !== 1) {
          this.$message.error(response.data.msg || '获取岗位列表失败')
          return
        }

        const responseData = response.data.data || {}
        const lists = responseData.lists || responseData || []
        const normalizedJobs = (Array.isArray(lists) ? lists : []).map(job => {
          if (!job) return job
          const normalized = { ...job }
          normalized.is_favorite = job.id ? this.favoriteJobs.has(job.id) : !!normalized.is_favorite
          return normalized
        })

        this.hotJobs = normalizedJobs
        this.jobsFetched = true
        
        // 选中第一个岗位
        if (this.hotJobs.length > 0) {
          this.selectedJob = this.hotJobs[0]
          if (this.selectedJob && this.selectedJob.job_address) {
            this.$nextTick(() => {
              this.initAmap()
            })
          }
        } else {
          this.selectedJob = null
        }
        
        this.$nextTick(() => {
          this.attachJobListScrollListener()
        })
      } catch (error) {
        console.error('获取岗位列表失败:', error)
        this.$message.error('获取岗位列表失败，请稍后重试')
      } finally {
        this.jobsIsLoading = false
      }
    },
    async loadHotJobs() {
      // 强制使用岗位类型
      this.searchParams.type = 1
      const cacheKey = 'jobSearchParams'
      // 确保使用正确的 page_size
        this.searchParams.page_size = JOB_LIST_PAGE_SIZE
      this[cacheKey] = { ...this.searchParams }

      const params = { ...this[cacheKey] }
      const pageNo = params.page_no || 1
      const pageSize = params.page_size || JOB_LIST_PAGE_SIZE

        this.jobsIsLoading = pageNo > 1
      this.isLoadingMore = pageNo > 1

      try {
        const response = await getHotJob(params);
        if (response.data.code !== 1) return

        const responseData = response.data.data || {};
        const lists = responseData.lists || [];
          const normalizedJobs = (Array.isArray(lists) ? lists : []).map(job => {
            if (!job) return job
            const normalized = { ...job }
            return normalized
          })
          if (pageNo === 1) {
            this.hotJobs = normalizedJobs;
            // 检查路由参数中是否有 job_id，如果有则选中对应岗位
            const jobIdFromRoute = this.$route.query.job_id
            if (jobIdFromRoute) {
              const targetJob = this.hotJobs.find(job => 
                (job.id && String(job.id) === String(jobIdFromRoute)) || 
                (job.job_id && String(job.job_id) === String(jobIdFromRoute))
              )
              if (targetJob) {
                this.selectedJob = targetJob
              } else {
                this.selectedJob = this.hotJobs[0] || null
              }
            } else {
              this.selectedJob = this.hotJobs[0] || null
            }
            // 初始化地图
            if (this.selectedJob && this.selectedJob.job_address) {
              this.$nextTick(() => {
                this.initAmap()
              })
            }
          } else {
            this.hotJobs = [...this.hotJobs, ...normalizedJobs];
          }
          this.jobsFetched = true
          this.jobsPageNo = pageNo
          this.jobsHasMore = Array.isArray(lists) && lists.length >= pageSize
          this.hasMore = this.jobsHasMore

        this.searchParams.page_no = pageNo
        this[cacheKey] = { ...this.searchParams }
      } catch (error) {
        console.error('获取热门岗位失败:', error);
        if (pageNo === 1) {
            this.hotJobs = [];
            this.selectedJob = null;
            this.jobsHasMore = false
        } else {
          // 失败后恢复上一页状态
          const previousPage = pageNo - 1
            this.jobsPageNo = previousPage
            this.jobsHasMore = true
            this.jobSearchParams = { ...this.jobSearchParams, page_no: previousPage }
          this.searchParams.page_no = previousPage
        }
        this.hasMore = this.jobsHasMore
      } finally {
        this.isLoadingMore = false
          this.jobsIsLoading = false
      }
    },
    // 触底后加载更多
    async loadMoreHotJobs() {
      const isLoading = this.jobsIsLoading
      const hasMore = this.jobsHasMore
      const currentPage = this.jobsPageNo
      if (isLoading || !hasMore) return;
      const nextPage = (currentPage || 1) + 1
      this.searchParams.page_no = nextPage;
        this.jobsPageNo = nextPage
      this.isLoadingMore = true;
        this.jobsIsLoading = true
      try {
        await this.loadHotJobs();
      } finally {
        this.isLoadingMore = false;
      }
    },
    selectJob(job) {
      this.selectedJob = job;
    },
    // 获取员工数量文本
    getEmployeeCountText(scale) {
      if (!scale) return ''
      if (typeof scale === 'string') {
        if (scale.includes('2000') || scale.includes('以上')) return '2000人以上'
        if (scale.includes('500')) return '500-2000人'
        if (scale.includes('100')) return '100-500人'
        return scale
      }
      return ''
    },
    // 获取融资阶段文本
    getFinancingText(recruitmentType) {
      if (!recruitmentType) return ''
      const typeMap = {
        'd_round': 'D轮及以上',
        'c_round': 'C轮',
        'b_round': 'B轮',
        'a_round': 'A轮',
        'angel': '天使轮',
        'no_financing': '不需要融资'
      }
      return typeMap[recruitmentType] || ''
    },
    applyFilters() {
      this.showJobFavorites = false
      this.searchParams.page_no = 1;
      this.hasMore = true;
      this.isLoadingMore = false;
      this.hotJobs = [];
      this.jobsFetched = false;
      this.jobsPageNo = 1;
      this.jobsHasMore = true;
      this.jobsIsLoading = false;
      this.syncSearchCache();
      this.loadHotJobs();
    },
    resetFilters() {
      this.showJobFavorites = false
      this.searchParams = {
        category: '',
        city: '',
        company_id: '',
        company_name: '',
        education: null,
        keyword: '',
        page_no: 1,
        page_size: JOB_LIST_PAGE_SIZE,
        publish_days: 0,
        salary_max: 0,
        salary_min: 0,
        sort_by: '',
        recruitment_type: '',
        job_keywords: null,
        job_objective: null,
        type: 1
      };
      this.hasMore = true;
      this.isLoadingMore = false;
      this.hotJobs = [];
      this.jobsFetched = false;
      this.jobsPageNo = 1;
      this.jobsHasMore = true;
      this.jobsIsLoading = false;
      this.jobSearchParams = { ...this.searchParams }
      this.loadHotJobs();
    },
    async toggleFavorite(job) {
      if (!job || !job.id) {
        console.error('职位信息无效');
        return;
      }
      
      try {
        if (job.is_favorite || this.favoriteJobs.has(job.id)) {
          // 取消收藏
          await cancelFavoriteJob({ job_id: job.id });
          if (this.favoriteJobs.has(job.id)) this.favoriteJobs.delete(job.id);
          // 更新当前项与列表的响应式标记
          this.$set(job, 'is_favorite', false)
          const idx = Array.isArray(this.hotJobs) ? this.hotJobs.findIndex(j => j.id === job.id) : -1
          if (idx > -1) this.$set(this.hotJobs[idx], 'is_favorite', false)
          if (this.selectedJob && this.selectedJob.id === job.id) this.$set(this.selectedJob, 'is_favorite', false)
          this.$message.success('取消收藏成功');
        } else {
          // 添加收藏
          await addFavoriteJob({ job_id: job.id });
          this.favoriteJobs.add(job.id);
          this.$set(job, 'is_favorite', true)
          const idx = Array.isArray(this.hotJobs) ? this.hotJobs.findIndex(j => j.id === job.id) : -1
          if (idx > -1) this.$set(this.hotJobs[idx], 'is_favorite', true)
          if (this.selectedJob && this.selectedJob.id === job.id) this.$set(this.selectedJob, 'is_favorite', true)
          this.$message.success('收藏成功');
        }
      } catch (error) {
        console.error('收藏操作失败:', error);
      }
    },
    isFavorite(jobId) {
      return this.favoriteJobs.has(jobId);
    },
    formatSalary,
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN');
    },
    formatDescription(text) {
      if (!text) return '';
      
      // 按换行符分割文本
      const lines = text.split('\n').filter(line => line.trim() !== '');
      
      // 将每一行包装在 li 标签中
      const listItems = lines.map(line => {
        const trimmedLine = line.trim();
        // 如果行以数字、字母或符号开头，保持原样
        // 否则添加项目符号
        if (trimmedLine.match(/^[\d\w\u4e00-\u9fa5]/)) {
          return `<li>${trimmedLine}</li>`;
        } else {
          return `<li>${trimmedLine}</li>`;
        }
      });
      
      return listItems.join('');
    },
    getRecruitmentTypeClass(type) {
      const typeMap = {
        'social': 'social',
        'campus': 'campus', 
        'intern': 'intern'
      };
      return typeMap[type] || 'campus';
    },
    getWorkNatureText(nature) {
      return getWorkNatureLabel(nature);
    },
    getExperienceText,
    getCompanyAvatar(companyName) {
      if (!companyName) return '公司';
      
      // 去掉地名前缀（匹配"XX市"、"XX省"等格式）
      let cleanName = companyName.replace(/^[^省市区县]+[省市县区]/, '');
      
      return cleanName.substring(0, 4);
    },
    formatWorkTime(value) {
      return (value || '')
        .split('&')
        .map(item => item.trim())
        .filter(Boolean);
    },
    formatWorkTags(value) {
      return (value || '')
        .split('/')
        .map(item => item.trim())
        .filter(Boolean);
    },
    getCompanyLogo() {
      // 根据公司名称返回对应的logo，这里使用默认的SVG
      return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgZmlsbD0iIzMzNjZGRiIvPgo8cGF0aCBkPSJNMTIgMTJIMjhWMjhIMTJWMjJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
    },
    switchAccount() {
      // 切换账号逻辑
      this.$router.push('/store/entry/loginQRCode');
    },
  },
  created() {
    this.syncPageWithRoute(this.$route)
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.isLogin();
    this.loadUserExpectList();
    if (sessionStorage.getItem('redirectToHotJobs') === 'true') {
      sessionStorage.removeItem('redirectToHotJobs');
      this.$nextTick(() => {
        this.$router.push({ name: 'hot-jobs' });
      });
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    this.detachJobListScrollListener()
    this.destroyAmap()
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutside = (e) => {
          // 检查 el 是否存在且是有效的 DOM 元素
          if (el && el.nodeType && el.contains && !el.contains(e.target)) {
            binding.value()
          }
        }
        document.addEventListener('click', el.clickOutside)
      },
      unbind(el) {
        if (el && el.clickOutside) {
          document.removeEventListener('click', el.clickOutside)
        }
      }
    },
    // 定义懒加载指令
    lazyload: {
      inserted(el, binding) {
        // 创建占位符
        const defaultPlaceholder = 'data:image/gif;base64,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';
        el.src = defaultPlaceholder;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.src = binding.value;
              observer.unobserve(el);
            }
          });
        }, { threshold: 0.01 });

        observer.observe(el);
      },
      componentUpdated(el, binding) {
        // 在组件更新时重新观察元素
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.src = binding.value;
              observer.unobserve(el);
            }
          });
        }, { threshold: 0.01 });

        observer.observe(el);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/styles/job-listings.scss';
// 定义颜色变量
$text-color: #656587;
$gradient-bg: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);

.text1 {
  color: $text-color;
}

.text2 {
  background: $gradient-bg;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.infinite-sentinel { height: 1px; }

.loading-state {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
}

.loading-state img {
  width: 200px;
  max-width: 60%;
}


// 会话存在确认弹层样式（确保覆盖页面并置顶显示）
.confirm-overlay {
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  background: rgba(0,0,0,.35);
  z-index: 4000; // 高于页面其它元素
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-dialog {
  background: #fff;
  border-radius: 16px;
  width: 420px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 12px 28px rgba(0,0,0,.18);
}
.confirm-dialog .dd-desc { color:#666; margin: 6px 0 16px; font-size: 16px }
.confirm-dialog .dd-actions { display:flex; gap:12px; justify-content:center; }
.confirm-dialog .dd-btn { padding:8px; font-size:12px; border-radius:8px; cursor:pointer; border:1px solid #eee; background:#fff; flex: 1 }
.confirm-dialog .button-color { background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%); color:#fff; border:none; }

/* 投递成功弹框样式 */
.deliver-success .success-illust { width: 180px; height: auto; margin: 4px auto 8px; display: block; }
.deliver-success .success-title { font-size: 22px; font-weight: 700; color: #6b76ff; margin: 8px 0 6px; }
.deliver-success .success-desc { font-size: 14px; color: #6b6f7c; line-height: 22px; margin: 0 0 16px; }
.deliver-success .dd-primary {
  flex: none;
  width: 160px;
  padding: 10px 0;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: #fff;
  border: none;
}
.deliver-success .dd-primary:hover { transform: translateY(-1px); }

.page-container {
  /*  background: linear-gradient(to bottom, #ffffff, #d9e2ff); */
  background: url("~@/views/index/assets/img/_1-10.png") no-repeat center / cover;
  padding: 20px;
  padding-bottom: 0;
  width: 100%;
  height: 100%;
  font-family: sans-serif;
  overflow-x: hidden;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 12px 24px;
  background: rgba(255, 255, 255, 0);
  backdrop-filter: blur(4px);
  transition: all 0.35s ease;
  box-shadow: none;
  min-height: 64px;
  padding-left: 24px;
  padding-right: 24px;
}

.header.scrolled {
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.logo {
  display: flex;
  align-items: center;
  height: 64px;
}

/* 品牌区 */
.brand {
  display: flex;
  align-items: center;
  gap: 8px;
}

.brand-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.brand-text {
  font-size: 20px;
  font-weight: 600;
  color: #4a3f9e;
}

/* 中间导航 */
.nav {
  display: none;
  gap: 32px;
}

.nav-link {
  font-size: 15px;
  color: #333;
  text-decoration: none;
  transition: color 0.25s;
}

.nav-link:hover {
  color: #4a3f9e;
}

/* 右侧按钮 */
.actions {
  display: none;
  gap: 12px;
}

.btn {
  padding: 9px 20px;
  border-radius: 20px;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.25s;
}

.btn-primary {
  background: #4a3f9e;
  color: #ffffff;
}

.btn-primary:hover {
  background: #6e65c4;
}

.btn-secondary {
  background: transparent;
  color: #4a3f9e;
  border: 1px solid #4a3f9e;
}

.btn-secondary:hover {
  background: #4a3f9e;
  color: #ffffff;
}

/* 汉堡按钮 */
.hamburger {
  display: block;
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
}

.hamburger span {
  display: block;
  width: 22px;
  height: 2px;
  background: #4a3f9e;
  margin: 5px auto;
  transition: all 0.3s;
}

/* 桌面端显示导航和按钮 */
@media (min-width: 992px) {
  .nav {
    display: flex;
  }

  .actions {
    display: flex;
  }

  .hamburger {
    display: none;
  }
}



.nav-buttons {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.btn-primary {
  background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  border-radius: 24px;
  color: white;
  border: none;
  width: 80px;
  height: 44px;
}

.btn-secondary {
  background-color: transparent;
  color: #7B6EF6;
  border: 1px solid #7B6EF6;
  width: 120px;
  height: 44px;
  border-radius: 24px;
}

/* Hero Section */
.section-title {
  font-size: 32px;
  font-weight: bold;
  color: #4A3F9E;
  margin-bottom: 20px;
  text-align: left;
}

/* .stats {
  font-size: 18px;
  color: #4A3F9E;
  margin-bottom: 20px;
  text-align: center;
  
} */


/* Responsive Design */
@media (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
  }



  .nav-buttons {
    flex-direction: column;
    width: 100%;
  }

  .nav-buttons .btn {
    width: 100%;
    margin-bottom: 10px;
  }

  .hero-section {
    flex-direction: column;
  }

  .hero-text {
    max-width: 100%;
    text-align: center;
  }

  .hero-buttons {
    justify-content: center;
  }



  .cooperation-content {
    flex-direction: column;
  }

  .cooperation-content img {
    max-width: 100%;
  }

  .section-title {
    font-size: 24px;
  }


}

.feature-title {

  background: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0%,
      rgba(177, 110, 249, 1) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  font-family: "Afacad-SemiBold", sans-serif;
  font-size: 28px;
  font-weight: 600;
}
.mt-2{
  margin-top: 20px
}
.feature-description {
  margin-top: 20px;
  color: #656587;
  text-align: left;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 18px;
  font-weight: 400;
}

.section-title {
  font-size: 28px;
  color: #4e7dff;
  margin-bottom: 15px;
}

.section-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
}

.partner-logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  /* Logo之间的间距 */

}

.partner-logo {
  width: 300px;
  height: 200px;

}

.contact-button {
  display: inline-block;
  padding: 10px 25px;
  background: var(--linear,
      linear-gradient(-39.22deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.6) 100%));

  border-radius: 25px;
  color: #f0fbff;
  text-align: center;
  font-family: "AdventPro-SemiBold", sans-serif;
  font-size: 22px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.contact-button:hover {
  background-color: #5545e0;
  box-shadow: 0 4px 12px rgba(106, 85, 255, 0.3);
}

@media (max-width: 768px) {
  .partner-logo {
    min-width: calc(50% - 20px);
    /* 在小屏幕上每行显示两个Logo */
    margin: 10px;
  }
}

footer {
  background-color: #6A6985;
  color: #fff;
  padding: 40px 0;
  font-size: 14px;
  line-height: 1.6;
  position: relative;
  overflow: hidden;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-bottom: 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.footer-left {
  flex: 1;
  text-align: left;
  margin-left: -50px;
}

.footer-nav {
  margin-bottom: 20px;
}

.nav-link {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #f0f0f0;
}

.nav-separator {
  margin: 0 10px;
  color: #fff;
}

.company-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #fff;
}

.company-address,
.company-email {
  font-size: 14px;
  margin-bottom: 8px;
  color: #fff;
}

.footer-mask {
  position: absolute;
  right: 0;
  z-index: 1;
  pointer-events: none;
  width: 60%;
  height: 95%;
}

.footer-mask img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.footer-logo {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  z-index: 2;
  width: 30%;
  height: 80%;
}

.footer-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  
  .footer-left {
    text-align: center;
    margin-left: -20px;
  }
  
  .footer-mask {
    width: 60%;
    height: 95%;
  }
  
  .footer-mask img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .footer-logo {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    width: 30%;
    height: 80%;
  }
  
  .footer-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .company-name {
    font-size: 15px;
  }
  
  .company-address,
  .company-email {
    font-size: 13px;
  }
  
  .nav-link {
    font-size: 13px;
  }
}

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
}


.carousel-caption {
  text-align: center;
  padding: 10px;
  background: linear-gradient(90deg,
      rgba(152, 144, 242, 1) 0%,
      rgba(153, 153, 153, 0) 100%);
  color: white;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  p {
    color: #ffffff;
    text-align: left;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 24px;
  }
}

.indicator-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator-dot.active {
  background-color: #ffffff;
  /* 当前活动圆点的颜色 */
  transform: scale(1.2);
  /* 当前活动圆点的大小变化 */
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 0 10px;
  }
}

.nav-center {
  display: flex;
  font-size: 16px;
  justify-content: space-around;
  align-items: center;
  flex: 1;
  max-width: 600px;
  margin: 0 auto;
  height: 64px;

  span {
    cursor: pointer;
    color: #333;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0 16px;
    white-space: nowrap;
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #ffffff;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #9383FF;
        transform: skew(-15deg);
        z-index: -1;
      }
    }
  }
}

.switch-box {
  display: flex;
  align-items: center;
  gap: 2px;
  width: 150px;
  height: 44px;
  border-radius: 22px;
  border: 1px solid #85AAED;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  font-family: "Source Han Sans CN VF";
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  fill: var(--linear-2-paints, linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%));
  filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.15));
  backdrop-filter: blur(15px);
}

.split-img {
  width: 16px;
  /* 按设计图调大小 */
  height: 16px;
  flex-shrink: 0;
  /* 防止被压缩 */
}

.switch-btn {
  flex: 1;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  background: var(--Linear, linear-gradient(180deg, rgba(177, 110, 249, 0.60) 0%, rgba(126, 180, 235, 0.60) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.switch-btn.active {
  background: none;
  background-clip: initial;
  -webkit-background-clip: initial;
  -webkit-text-fill-color: initial;
  color: #666;
}






// 头部内容布局样式
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}

.user-section {
  display: flex;
  align-items: center;
  height: 36px;
}

.switch-box {
  display: flex;
  align-items: center;
  height: 36px;
  width: 170px;
  gap: 8px;
  padding: 4px 10px 4px 6px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%) border-box;
  box-shadow: 0 2px 8px rgba(124, 142, 255, 0.25);
}

.switch-btn {
  padding: 6px 12px;
  border: none;
  background: #f5f5f5;
  color: #656587;
  -webkit-text-fill-color: #656587;
  background-clip: initial;
  -webkit-background-clip: initial;
  font-size: 13px;
  font-weight: 500;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 28px;
  display: flex;
  align-items: center;
}

.switch-btn:hover {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: #fff;
  border-color: transparent;
}

.switch-btn.active {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: #fff;
  -webkit-text-fill-color: #fff;
  border-color: transparent;
  box-shadow: none;
}

/* 当鼠标进入容器时，如果激活按钮不是被悬浮的那个，则取消其高亮 */
.switch-box:hover .switch-btn.active:not(:hover) {
  background: #f5f5f5;
  color: #656587;
  -webkit-text-fill-color: #656587;
}

.switch-btn.active:hover {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: #fff;
  border-color: transparent;
}

// ProfileButton样式
.user-info {
  position: relative;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 10px 0 4px;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #e5e5e5;
  border-radius: 18px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, .08);
  cursor: pointer;
  transition: all .16s ease;
}

.user-info:hover {
  border-color: #0071e3;
  box-shadow: 0 4.8px 19.2px rgba(0, 113, 227, .25);
}

.avatar-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.text {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
}

.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #F9F9FB;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .12);
  min-width: 160px;
  z-index: 1001;
  margin-top: 6px;
  max-height: 400px;
  overflow-y: auto;
}

.user-dropdown-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #e4e7ed;
}

.user-dropdown-menu::after {
  content: '';
  position: absolute;
  top: -5px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 13px;
  color: #333;
}

.menu-item:hover .txt {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.menu-item:hover .icon-left {
  filter: hue-rotate(200deg) saturate(1.5) brightness(1.2);
}

.menu-item:hover i {
  color: #77BAFF;
}

.menu-item i {
  font-size: 16px;
  color: #666;
}

.menu-item:first-child {
  border-radius: 10px 10px 0 0;
}

.menu-item:last-child {
  border-radius: 0 0 10px 10px;
}

.menu-divider {
  height: 1px;
  background-color: #e4e7ed;
  margin: 4px 0;
}

.icon-left {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.txt {
  flex: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .16s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 开发中弹窗样式
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.development-dialog {
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
}

.development-content {
  text-align: center;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.development-image {
  max-width: 300px;
  height: auto;
  border-radius: 8px;
}

.development-text {
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

.close-button {
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
  border: none;
  border-radius: 6px;
  padding: 10px 30px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(126, 180, 235, 0.4);
  }
}

/* 意见反馈弹窗样式已移至 FeedBack 组件 */

.submit-btn,
.cancel-btn {
  width: 10vw;
  min-width: 100px;
  height: 8vh;
  min-height: 40px;
  border-radius: 2vw;
  font-size: 1vw;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
}

.submit-btn {
  background: linear-gradient(90deg, #7EB4EB, #B16EF9);
  color: white;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  color: #666;
}

.submit-btn:hover,
.cancel-btn:hover {
  transform: translateY(-0.2vh);
  box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

/* Hide all scrollbars */
* {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

*::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* Hot Jobs Styles */
.hot-jobs-container {
  width: 100vw;
  height: calc(100vh - 60px);
//   background: #f8f9fa;
  padding: 0;
  margin: 0;
  margin-top: 40px;
  margin-left: calc(-50vw + 50%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.search-filter-bar {
  padding: 0px 130px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e5e5;
  background: linear-gradient(320.78deg, rgba(255, 255, 255, 0.4) 2.06%, rgba(255, 255, 255, 0.723077) 42.17%, rgba(255, 255, 255, 0.8) 99.08%);
  
  &.has-selected-company {
    padding: 0px 150px;
  }
}

.search-tabs {
  display: flex;
  align-items: baseline;

  .tabs-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    color: #656587;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      border-color: #62AFFF;
      color: #62AFFF;
      background: rgba(98, 175, 255, 0.05);
    }
    
    &:active {
      transform: scale(0.95);
    }
    
    svg {
      display: block;
    }
  }

  .tab {
    padding: 6px 14px;
    margin-right: 12px;
    cursor: pointer;
    font-size: 14px;
    line-height: 22px;
  }

  /* 相关岗位 - 渐变背景，圆角4px */
  .tab-jobs {
    border-radius: 4px;
    color: #fff;
    background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  }

  /* 相关企业 - 1px描边、圆角4px，透明背景 */
  .tab-companies {
    border-radius: 4px;
    border: 1px solid var(--linear-2-paints, #62AFFF);
    color: #656587;
    background: transparent;
  }
  
  /* 激活状态下的相关企业标签 */
  .tab-companies.active {
    border-radius: 4px;
    color: #fff;
    background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
    border: none;
  }
  
  /* 激活状态下的相关岗位标签 */
  .tab-jobs.active {
    border-radius: 4px;
    color: #fff;
    background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  }
}

.search-section {
  margin-top: 12px;
  margin-bottom: 20px;
  flex: 1;
}

/* 胶囊搜索盒（UI：白底+渐变描边） */
.search-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  border-radius: 8px;
  padding: 0 0 0 8px;
  background: #fff;
  border: 1px solid transparent;
  background-image: linear-gradient(#fff, #fff),
    var(--linear-2-paints, linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: 0 6px 14px rgba(124, 142, 255, 0.15);
}

.search-left {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  padding-left: 8px;
}

.icon-search {
  width: 18px;
  height: 18px;
  display: inline-block;
  object-fit: contain;
}

.search-input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  color: #333;
}

.search-right {
  display: flex;
  align-items: center;

  margin-left: auto;

}

/* 求职期望下拉样式修正，避免被其他模块样式影响 */
.expect-select-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.expect-select-wrapper .label {
  color: #656587;
  font-size: 14px;
  line-height: 1;
}

.expect-select {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #656587;
  font-size: 14px;
  height: 44px;
  padding: 0 12px;
  position: relative;

  border: 1px solid transparent;
  background: #fff;
  background-image: linear-gradient(#fff, #fff),
    var(--linear-2-paints, linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  cursor: pointer;
}

.expect-select .label { color: #9aa4b2; }
.expect-select .value { color: #656587; }
.expect-select .caret { 
  color: #9aa4b2; 
  font-size: 12px; 
  transition: transform 0.3s ease;
}
.expect-select .caret.active {
  transform: rotate(180deg);
}

// 岗位选择下拉框样式
.position-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
}

.dropdown-item {
  padding: 8px 12px;
  font-size: 14px;
  color: #656587;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-item.active {
  background-color: #e3f2fd;
  color: #1976d2;
}

.btn-add-expect {
  height: 44px;
  padding: 0 10px;
  border: 1px solid transparent;
  background: #fff;
  background-image: linear-gradient(#fff, #fff),
    var(--linear-2-paints, linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  color: #656587;
  font-size: 12px;
  cursor: pointer;
  margin-right: 0;
}

.filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #656587;
  font-family: "Source Han Sans CN VF";
  font-style: normal;
  font-weight: 400;
  
  .filter-select {
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    background: none;
    color: #656587;
    font-family: "Source Han Sans CN VF";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    
    &:focus {
      outline: none;
      border-color: transparent;
    }
  }
  
  .favorites-link {
    color: #656587;
    cursor: pointer;
    font-size: 14px;
    font-family: "Source Han Sans CN VF";
    font-style: normal;
    font-weight: 400;
    
    &:hover {
      text-decoration: none;
    }

    &.active {
      color: #9C41FF;
      background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 600;
    }
  }
  
  .reset-filters-btn {
    padding: 8px 12px;
    background: #f0f0f0;
    border: none;
    border-radius: 4px;
    color: #656587;
    cursor: pointer;
    font-size: 14px;
    font-family: "Source Han Sans CN VF";
    font-style: normal;
    font-weight: 400;
    
    &:hover {
      background: #e0e0e0;
    }
  }
}

.main-content-area {
  display: flex;
  flex: 1;
  padding: 20px 140px;
  gap: 20px;
  overflow: hidden;
  justify-content: center;

  // 在 main-content-area 中，job-listings-panel 和 job-details-panel 需要固定宽度
.job-listings-panel {
  width: 40%;
  max-height: calc(100vh - 220px);
}

  .job-details-panel {
    width: 60%;
  max-height: calc(100vh - 220px);
  }
}

// 职位列表和详情样式已移至 @/styles/job-listings.scss

.job-detail-header {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 20px;
  margin-bottom: 24px;
  
  .job-header-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
  }
  
  .salary-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    
    .salary {
      font-size: 20px;
      font-weight: 600;
      background: $gradient-bg;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    .action-icons {
      display: flex;
      gap: 8px;
      
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: all 0.2s ease;
        
        img {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
        
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
      }
      
      .favorite-icon {
        &.active {
          transform: scale(1.1);
          
          img {
            filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);
          }
        }
      }
    }
  }
  
  .job-title-section {
    flex: 1;
    
    .title-with-tags {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    
    .detail-job-title {
      font-size: 24px;
      font-weight: 600;
      color: $text-color;
      margin: 0;
      max-width: 460px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .job-tags {
      display: flex;
      gap: 8px;
      
      .tag {
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
        
        &.social {
          border-radius: 4px;
          border: 1px solid #FF8400;
          background: rgba(255, 132, 0, 0.10);
          color: #FF8400;
        }
        
        &.online {
          background: #f6ffed;
          color: #52c41a;
        }
        &.campus {
          background: #fff7e6;
          color: #fa8c16;
        }
      }
    }
  }
  
  .job-meta {
    .meta-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    
    .job-basic-info {
      display: flex;
      gap: 16px;
      
      span {
        font-size: 14px;
        color: $text-color;
        display: fle;
        gap: 2px;
        align-items: center;
      }
      
      .info-item {
        display: flex;
        align-items: center;
        gap: 4px;
        max-width: 90%;
        min-width: 0;
        
        .info-text {
          flex: 1;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info-icon {
          width: 14px;
          height: 14px;
          object-fit: contain;
        }
      }
    }
    
    .update-info {
      font-size: 12px;
      color: #999;
      flex-shrink: 0;
    }
  }
}

.job-description-section {

  padding: 20px;
  
  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
  }
  
  .job-tags {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
    
    .tag {
      padding: 4px 8px;
      background: #f0f0f0;
      border-radius: 4px;
      font-size: 12px;
      color: #666;
    }
  }
  
  .responsibilities, .qualifications {
    margin-bottom: 20px;
    color: $text-color;
    
    h4 {
      font-size: 16px;
      font-weight: 600;
      color: $text-color;
      margin-bottom: 12px;
    }
    
    ul {
      margin: 0;
      padding-left: 20px;
      list-style-type: decimal; /* 添加数字序号 */
      font-size: 14px; /* 确保ul下的字体为14px */
      
      li {
        font-size: 14px !important; /* 强制设置字体大小 */
        color: $text-color;
        line-height: 1.6;
        margin-bottom: 8px;
        list-style-position: outside; /* 序号在外部 */
      }

      &.no-list-style {
        list-style-type: none;
        padding-left: 0;
        
        li {
          padding-left: 0;
        }
      }
    }
  }
}

.work-location-section {
  margin-bottom: 24px;
  
  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
  }
  
  .location-map {
    position: relative;
    
    .amap-container {
      height: 300px;
      width: 100%;
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #e5e5e5;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
    
    .map-placeholder {
      height: 200px;
      background: #f5f5f5;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e5e5e5;
      
      .map-content {
        text-align: center;
        
        .location-pin {
          font-size: 24px;
          margin-bottom: 8px;
        }
        
        .location-text {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}

.company-info-section {
  margin-bottom: 24px;
  
  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
  }
  
  .company-card {
    display: flex;
    align-items: center;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    cursor: pointer;
    
    &:hover {
      background: #f0f0f0;
    }
    
    .company-logo {
      width: 40px;
      height: 40px;
      margin-right: 16px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
      border-radius: 4px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
        display: block;
      }
      
      .company-logo-text {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        color: #666;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-radius: 4px;
      }
    }
    
    .company-details {
      flex: 1;
      
      .company-name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
      }
      
      .company-info-text {
        font-size: 12px;
        color: #666;
        line-height: 1.4;
        white-space: normal;
        word-wrap: break-word;
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }
    
    .company-arrow {
      font-size: 16px;
      color: #999;
    }
  }
}

.action-buttons {
  display: flex;
  gap: 16px;
  position: sticky;
  bottom: 4px;
  padding: 0px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  margin: 0;
  border-top: 1px solid #eee;
  z-index: 2;
  
  .btn-interview {
    flex: 1;
    padding: 12px 24px;
    background: white;
    border: 2px solid;
    border-image: $gradient-bg 1;
    background: $gradient-bg;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .btn-apply {
    flex: 1;
    padding: 12px 24px;
    background: $gradient-bg;
    border: none;
    color: white;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(124, 65, 255, 0.3);
    }
  }
}

/* 投递材料弹窗样式 */
::v-deep .submit-dialog {
  .el-dialog__wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    overflow: hidden !important;
    z-index: 2000 !important;
  }
  
  .el-dialog {
    position: fixed !important;
    top: 50% !important;
    left: auto !important;
    right: auto !important;
    transform: translateY(-50%) !important;
    margin: 0 auto !important;
    max-height: 80vh !important;
    overflow: hidden !important;
    z-index: 2001 !important;
  }
}

.submit-dialog {
  .el-dialog__wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden !important;
    z-index: 2000 !important;
  }
  
  .el-dialog {
    position: fixed !important;
    top: 50% !important;
    left: auto !important;
    right: auto !important;
    transform: translateY(-50%) !important;
    margin: 0 auto !important;
    max-height: 80vh !important;
    overflow: hidden !important;
    z-index: 2001 !important;
  }
  
  .el-dialog__body {
    position: relative !important;
    overflow: hidden !important;
  }
  
  .el-dialog__header {
    text-align: center;
    padding: 20px 20px 10px;
    
    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: $text-color;
    }
  }
  
  .el-dialog__body {
    padding: 0 16px 16px;
    max-height: 60vh;
    overflow-y: auto;
  }
  
  .submit-content {
    .section {
      margin-bottom: 20px;
      
      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: $text-color;
        margin-bottom: 12px;
      }
      
      .material-list {
        .material-item {
          display: flex;
          align-items: center;
          padding: 10px;
          border: 1px solid #e4e7ed;
          border-radius: 6px;
          margin-bottom: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          
          &:hover {
            border-color: #7C41FF;
            background-color: #f8f9ff;
          }
          
          &.active {
            border-color: #7C41FF;
            background-color: #f8f9ff;
          }
          
          .material-icon {
            width: 40px;
            height: 40px;
            margin-right: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            img {
              width: 24px;
              height: 24px;
            }
          }
          
          .material-info {
            flex: 1;
            
            .material-name {
              font-size: 14px;
              font-weight: 500;
              color: $text-color;
              margin-bottom: 4px;
            }
            
            .material-date {
              font-size: 12px;
              color: #909399;
            }
          }
          
          .material-radio {
            input[type="radio"] {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
  
  .dialog-footer {
    text-align: center;
    padding: 20px;
    border-top: 1px solid #e4e7ed;
    
    .el-button {
      margin: 0 8px;
      padding: 8px 24px;
    }
  }
}
</style>